import Model from "../Model";

export interface TPortalForm {
  id: number;
  publicationDate: Date;
  name: string;
}

export interface IPortalForm extends TPortalForm {}

const PortalForm = Model(
  (model: TPortalForm): IPortalForm => {
    const _portalForm: TPortalForm = Object.assign({}, model);

    return {
      get id() {
        return _portalForm.id;
      },
      get publicationDate() {
        return _portalForm.publicationDate;
      },
      get name() {
        return _portalForm.name;
      }
    };
  }
);

export default PortalForm;
